import { apiClient } from './client';

export interface ReturnStatus {
  id: number;
  title: string;
  color: string;
  is_resolved: boolean;
  is_default: boolean;
  status_category: 1 | 2 | 3;
  sort_order: number;
  translations: Record<string, string>;
  show_in_menu: boolean;
  jtl_return_state_id?: number | null;
  system_key?: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreateReturnStatusPayload {
  title: string;
  color: string;
  is_resolved: boolean;
  status_category: 1 | 2 | 3;
  translations?: Record<string, string>;
  show_in_menu?: boolean;
}

export interface UpdateReturnStatusPayload {
  title?: string;
  color?: string;
  is_resolved?: boolean;
  status_category?: 1 | 2 | 3;
  translations?: Record<string, string>;
  show_in_menu?: boolean;
}

export interface ReorderReturnStatusesPayload {
  ordered_ids: number[];
}

export const configReturnStatusesApi = {
  listStatuses: async (): Promise<ReturnStatus[]> => {
    const response = await apiClient.get<ReturnStatus[]>('/config-return-statuses');
    return response.data;
  },

  createStatus: async (payload: CreateReturnStatusPayload): Promise<ReturnStatus> => {
    const response = await apiClient.post<ReturnStatus>('/config-return-statuses', payload);
    return response.data;
  },

  updateStatus: async (id: number, payload: UpdateReturnStatusPayload): Promise<ReturnStatus> => {
    const response = await apiClient.put<ReturnStatus>(`/config-return-statuses/${id}`, payload);
    return response.data;
  },

  deleteStatus: async (id: number): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.delete<{ success: boolean; message: string }>(
      `/config-return-statuses/${id}`,
    );
    return response.data;
  },

  reorderStatuses: async (payload: ReorderReturnStatusesPayload): Promise<ReturnStatus[]> => {
    const response = await apiClient.put<ReturnStatus[]>(
      '/config-return-statuses/reorder',
      payload,
    );
    return response.data;
  },

  translateBatch: async (
    text: string,
    targetLangs: string[],
  ): Promise<{ translations: Record<string, string> }> => {
    const response = await apiClient.post<{ translations: Record<string, string> }>(
      '/config-return-statuses/translate-batch',
      { text, target_langs: targetLangs },
    );
    return response.data;
  },
};
